import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { PageHeader } from '@/components/ui/PageHeader'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { Suspense } from 'react'
import { PlatformBreadcrumbs } from './PlatformBreadcrumbs'
import { RedisMenu } from './RedisMenu'
import { columns } from './PlatformFailedLoginsTable/platformFailedLoginsTableColumns'

export function PlatformFailedLoginsPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Failed Logins" />}>
        <RedisMenu />
      </PageHeader>
      <QueryErrorBoundary errorMessage="Failed to load failed logins">
        <Suspense fallback={<LoadingComponent text="Loading failed logins..." />}>
          <PlatformFailedLoginsPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function PlatformFailedLoginsPageContent() {
  const { getSupportApiGetFailedLogins } = useRestClient()
  const { data: failedLogins } = getSupportApiGetFailedLogins.useSuspenseQuery(undefined)

  return (
    <TablePageContainer>
      <DataTable columns={columns} data={failedLogins} />
    </TablePageContainer>
  )
}
